import Vue from 'vue';
import Router from 'vue-router';
import WithSidebar from '@/layouts/with-sidebar.vue';
import WithoutSidebar from '@/layouts/without-sidebar.vue';

import RouletteEdit from '@/views/roulette-edit.vue';
import RouletteCreate from '@/views/roulette-create.vue';
import Login from '@/views/login.vue';
import Home from '@/views/home.vue';
import Account from '@/views/account.vue';
import Success from '@/views/success.vue';
import Report from '@/views/report.vue';
import GetStarted from './views/onboarding/get-started.vue';
import CompanyRole from './views/onboarding/company-role.vue';
import MatchFrequency from './views/onboarding/match-frequency.vue';
import RouletteName from './views/onboarding/roulette-name.vue';
import TrialExplainer from './views/onboarding/trial-explainer.vue';
import TrialSuccess from './views/trial-success.vue';
import ScheduleEvent from './views/schedule-event.vue';
import store from './store';

Vue.use(Router);

const ensureAuthentication = async (to, from, next) => {
  if (to.path === '/login') return next();
  if (to.name === 'schedule-event' || to.path.includes('/schedule-event')) return next();

  try {
    await store.dispatch('authenticate');

    const { showOnboarding, onboardingStep } = store.state.login;
    const isOnboardingRoute = to.meta.isOnboarding;
    const needsOnboarding = showOnboarding && onboardingStep !== 'complete';

    if (needsOnboarding) {
      if (!isOnboardingRoute) {
        if (onboardingStep === 'complete') {
          return next({ name: 'trial-explainer' });
        }
        return next({ name: onboardingStep });
      }
    } else if (isOnboardingRoute) {
      return next('/home');
    }

    return next();
  } catch (e) {
    return next('/login');
  }
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { layout: WithSidebar },
    },
    {
      path: '/onboarding',
      name: 'get-started',
      component: GetStarted,
      meta: { hideNavbar: true, isOnboarding: true },
    },
    {
      path: '/onboarding/role',
      name: 'company-role',
      component: CompanyRole,
      meta: { hideNavbar: true, isOnboarding: true },
    },
    {
      path: '/onboarding/teammembers',
      name: 'match-frequency',
      component: MatchFrequency,
      meta: { hideNavbar: true, isOnboarding: true },
    },
    {
      path: '/onboarding/roulette',
      name: 'roulette-name',
      component: RouletteName,
      meta: { hideNavbar: true, isOnboarding: true },
    },
    {
      path: '/onboarding/trial',
      name: 'trial-explainer',
      component: TrialExplainer,
      meta: { hideNavbar: true, isOnboarding: true },
    },
    {
      path: '/trial-success',
      name: 'trial-success',
      component: TrialSuccess,
      meta: { layout: WithoutSidebar, hideNavbar: true, isOnboarding: true },
    },
    {
      path: '/create',
      name: 'create',
      component: RouletteCreate,
      meta: { layout: WithSidebar },
    },
    {
      path: '/edit/:id',
      name: 'edit',
      props: true,
      component: RouletteEdit,
      meta: { layout: WithSidebar },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { layout: WithoutSidebar },
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: { layout: WithoutSidebar },
    },
    {
      path: '/success',
      name: 'success',
      component: Success,
      meta: { layout: WithoutSidebar },
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      meta: { layout: WithoutSidebar },
    },
    {
      path: '/schedule-event/:id',
      name: 'schedule-event',
      component: ScheduleEvent,
      meta: { hideNavbar: true, layout: WithoutSidebar },
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach(ensureAuthentication);

export default router;
